import unescapedText from 'I18n/utils/unescapedText';
import { UsageScreenProvider } from 'marketplace-ui-tracking';
import { NavMarker } from 'react-rhumb';
import { DashboardPageWithHero } from '../components/DashboardPageWithHero';
import { StorefrontPageMetadata } from '../components/StorefrontPageMetadata';
import { ProductPageHeader } from '../components/headers/ProductPageHeader';
import { AGENT_MIN_SECTION_CARD_COUNT, APP_MIN_SECTION_CARD_COUNT } from '../constants/suggestions';
import { Screens } from '../constants/usage';
import { useGetSuggestionSections } from '../hooks/useGetSuggestionSections';
import { useSplitSuggestionSections } from '../hooks/useSplitSuggestionSections';
import { useTrackHomepageViewedEvent } from '../hooks/useTrackHomepageViewedEvent';
import { ProductHomeSections } from './components/ProductHomeSections';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function ProductPage({
  featuredCollectionId,
  productType
}) {
  const pathKey = productType === 'APP' ? 'APPS' : 'AGENTS';
  const screen = productType === 'APP' ? Screens.APPS : Screens.AGENTS;
  const {
    error,
    loading,
    data
  } = useGetSuggestionSections({
    productTypes: [productType],
    minimumSectionCardCount: productType === 'AGENT' ? AGENT_MIN_SECTION_CARD_COUNT : APP_MIN_SECTION_CARD_COUNT
  });
  const {
    sections,
    remainingSections
  } = useSplitSuggestionSections({
    suggestionSections: data === null || data === void 0 ? void 0 : data.result.sections,
    start: 0,
    end: 2
  });
  useTrackHomepageViewedEvent({
    loading,
    screen,
    sections: data === null || data === void 0 ? void 0 : data.result.sections,
    type: String(productType)
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [productType === 'APP' && /*#__PURE__*/_jsx(NavMarker, {
      name: "APPS_LOAD"
    }), productType === 'AGENT' && /*#__PURE__*/_jsx(NavMarker, {
      name: "AGENTS_LOAD"
    }), /*#__PURE__*/_jsx(StorefrontPageMetadata, {
      loading: loading,
      title: productType === 'AGENT' ? unescapedText('marketplaceStorefront.documentHead.agents.title') : unescapedText('marketplaceStorefront.documentHead.apps.title'),
      metaDescription: productType === 'AGENT' ? unescapedText('marketplaceStorefront.documentHead.agents.metaDescription') : unescapedText('marketplaceStorefront.documentHead.apps.metaDescription')
    }), /*#__PURE__*/_jsx(UsageScreenProvider, {
      screen: screen,
      children: /*#__PURE__*/_jsx(DashboardPageWithHero, {
        headerComponent: /*#__PURE__*/_jsx(ProductPageHeader, {
          pathKey: pathKey
        }),
        children: /*#__PURE__*/_jsx(ProductHomeSections, {
          error: error,
          featuredCollectionId: featuredCollectionId,
          loading: loading,
          productType: productType,
          remainingSections: remainingSections,
          sections: sections
        })
      })
    })]
  });
}